import { Container } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router";
import AddUsuario from "./AddUsuario";
import ListUsuario from "./ListUsuario";

function UsuarioIndex({t}){

    let {path, url} = useRouteMatch();
    return (
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><ListUsuario url={url}/></Route>
                <Route exact path={`${path}/crear`}><AddUsuario /></Route>
            </Switch>            
        </Container>
    )
}

export default withTranslation()(UsuarioIndex)